import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DataTable} from './DataTable';
import {DefaultSorter} from './DefaultSorter';
import {Paginator} from './Paginator';
import {BootstrapPaginator} from './BootstrapPaginator';
import { DataTableHeader } from './DataTableHeader.component';
import { DataTableSorter } from './DataTableSorter.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        DataTable,
        DefaultSorter,
        DataTableSorter,
        Paginator,
        BootstrapPaginator,
        DataTableHeader
    ],
    exports: [
        DataTable,
        DefaultSorter,
        DataTableSorter,
        Paginator,
        BootstrapPaginator,
        DataTableHeader
    ]
})
export class DataTableModule {

}
